import { render, staticRenderFns } from "./office.vue?vue&type=template&id=7fd81f60"
import script from "./office.vue?vue&type=script&lang=js"
export * from "./office.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports